if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='a4ad845fe9']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "a4ad845fe9");
	style.appendChild(document.createTextNode(".boot-site-icon{display:flex}.boot-site-icon__icon{fill:var(--wpds-color-fg-content-neutral,#1e1e1e);height:32px;width:32px}.boot-site-icon__image{aspect-ratio:1/1;border-radius:var(--wpds-border-radius-md,4px);height:32px;object-fit:cover;width:32px}"));
	document.head.appendChild(style);
}
